import React,{useContext} from "react";
import {AxiosRequestWithImba} from "../../helpers/AxiosRequest";
import {message} from "antd";
import {RoleContext} from "../../contexts/RoleContext";
import {DeleteContext} from "../../contexts/DeleteContext";

const DeleteMsg = ({msg, imba_id}) => {
    const {getDelete} = useContext(DeleteContext);
    const {setDelete} = useContext(DeleteContext);
    let deleted = getDelete()

    const success = (text) => {
        message.success(text);
    }

    const onDelete = (record) => {
        AxiosRequestWithImba('delete_msg', {
            user_id: localStorage.getItem('comet-user-id'),
            msg_user_id: record.user_id,
            msg_id: record.id,
            uuid: record.uuid,
            chat_role: 'admin'
        }, imba_id).then((data) => {
            deleted = getDelete()
            if (deleted==0) setDelete(1);
            else setDelete(0);
            success('Message successfully deleted!')
        })
    }
    const {getRole} = useContext(RoleContext);
    const role = getRole()


    if(role !='operator'){
        return (
            <a id={`delete-${msg.id}`} className={'button'} onClick={() => onDelete(msg)}>delete</a>
        )
    }
    else{
        return (<></>)
    }
}

export default DeleteMsg;